import { FC, useContext } from 'react';

import { LocaleIcon, Paragraph } from '@smartshell/ui-kit';
import cn from 'classnames';

import { useOutsideClicker } from 'hooks';
import {
  getLanguageTitle,
  LANGUAGE_OPTIONS,
  LocalizationContext,
} from 'localization';

import s from './LanguageSwitcher.module.scss';

export const LanguageSwitcher: FC = () => {
  const { t, lang, setLang } = useContext(LocalizationContext);

  const { ref, isComponentVisible, setIsComponentVisible } =
    useOutsideClicker<HTMLDivElement>(false, s.languages);

  return (
    <>
      <div
        className={s.container}
        onClick={() => setIsComponentVisible((prev) => !prev)}
        ref={ref}
      >
        <LocaleIcon />
        {t('language')}
        <div className={s.current_language}>
          <Paragraph color="secondary">{getLanguageTitle(lang)}</Paragraph>
        </div>
        {isComponentVisible && (
          <div className={s.languages}>
            {LANGUAGE_OPTIONS.map(({ value, title }) => (
              <div
                key={value}
                className={cn(s.language, value === lang && s.selected)}
                onClick={(event) => {
                  event.stopPropagation();
                  setLang(value);
                  setIsComponentVisible(false);
                }}
              >
                <Paragraph bold size="s">
                  {title}
                </Paragraph>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
